// ImpactSummarySection.jsx
import React from "react";
import "./ImpactSummarySection.css";

import Earth from "../assets/images/Earth.jpeg"

import { motion } from "framer-motion";

import Icon1 from "../assets/images/earth1.png";
import Icon2 from "../assets/images/earth2.png";
import Icon3 from "../assets/images/earth3.png";
import Icon4 from "../assets/images/earth4.png";


const ImpactSummarySection = () => {
  const impacts = [
  {
    icon: Icon1,
    text: "+25% improvement in traffic efficiency"
  },
  {
    icon: Icon2,
    text: "+40% optimisation in EV network siting"
  },
  {
    icon: Icon3,
    text: "–15% emergency response time"
  },
  {
    icon: Icon4,
    text: "4 continents | 6 active cities | 12 institutional partners"
  }
];

  return (
    <motion.section
      initial={{ opacity: 0, y: 80 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: false, amount: 0.3 }}
    >
      <div className="summary-container">
        <div className="impact-header">
        <h2 className="impact-title">Impact Summary</h2>
        <p className="impact-subtitle">
            Quantifiable impact across mobility, safety, and sustainability.
        </p>
        </div>

        <div className="earth-container">
          <img
            src={Earth}
            alt="Earth globe"
            className="earth-image"
          />
        </div>

        <div className="impact-stats">
          {impacts.map((item, index) => (
            <motion.div
              key={index}
              className="stat-item"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.2, duration: 0.6 }}
              viewport={{ once: false }}
            >
              <div className="icon-wrapper">
                <img src={item.icon} alt="" width={24} height={24} />
            </div>
              <span className="stat-text">{item.text}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default ImpactSummarySection;